import { Box } from "@mui/material";

// eslint-disable-next-line react-refresh/only-export-components
export const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

interface TabPanelProps {
  value: number;
  index: number;
  children: React.ReactNode;
}

// React component to display the tab content.
export function TabPanel({
  value,
  index,
  children,
}: TabPanelProps): JSX.Element {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
